var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "forgot-password-form" }, [
    _vm.hasError
      ? _c(
          "div",
          { staticClass: "alert alert-danger", attrs: { role: "alert" } },
          [
            _c("i", { staticClass: "fas fa-exclamation-triangle" }),
            _vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n  "),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.successMessage
      ? _c(
          "div",
          { staticClass: "alert alert-success", attrs: { role: "alert" } },
          [
            _c("i", { staticClass: "fas fa-check-circle" }),
            _vm._v("\n    " + _vm._s(_vm.successMessage) + "\n  "),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "form",
      {
        staticClass: "auth-form",
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.handleSubmit.apply(null, arguments)
          },
        },
      },
      [
        _c("div", { staticClass: "form-group" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.email,
                expression: "email",
              },
            ],
            staticClass: "form-control",
            class: { "is-invalid": _vm.errors.email },
            attrs: {
              id: "email",
              type: "email",
              placeholder: "Enter your email",
              required: "",
              disabled: _vm.isLoading,
            },
            domProps: { value: _vm.email },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.email = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _vm.errors.email
            ? _c("div", { staticClass: "invalid-feedback" }, [
                _vm._v("\n        " + _vm._s(_vm.errors.email[0]) + "\n      "),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-primary btn-block",
            attrs: { type: "submit", disabled: _vm.isLoading },
          },
          [
            _vm.isLoading
              ? _c("span", { staticClass: "loading-spinner" })
              : _vm._e(),
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.isLoading ? "Sending Reset Link..." : "Send Reset Link"
                ) +
                "\n    "
            ),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "form-footer" }, [
      _c(
        "p",
        { staticClass: "signin-link" },
        [
          _vm._v("\n      Remember your password?\n      "),
          _c(
            "router-link",
            {
              staticClass: "link-primary",
              attrs: { to: `/${_vm.currentLocale}/auth/login` },
            },
            [_vm._v("\n        Sign in here\n      ")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }